// Shared onboarding data used by WelcomeModal, WelcomeCard, and HowItWorks

export const TIER_FEATURES = {
  pro: [
    { icon: 'fa-bullseye',           text: '50 AI job matches per month' },
    { icon: 'fa-bolt',               text: '50 auto-applications per month' },
    { icon: 'fa-chart-line',         text: 'Full tracking dashboard' },
    { icon: 'fa-chalkboard-teacher', text: 'Interview prep tips' },
    { icon: 'fa-headset',            text: 'Priority support' },
  ],
  premium: [
    { icon: 'fa-infinity',           text: 'Unlimited job matches' },
    { icon: 'fa-bolt',               text: 'Unlimited auto-applications' },
    { icon: 'fa-file-medical-alt',   text: 'AI CV optimisation' },
    { icon: 'fa-chart-bar',          text: 'Salary insights' },
    { icon: 'fa-chalkboard-teacher', text: 'Interview prep tips' },
    { icon: 'fa-headset',            text: 'Dedicated support' },
  ],
};

export const SEEKER_STEPS = [
  {
    number: 1,
    icon: 'fa-upload',
    title: 'Upload Your CV',
    description: 'Upload your CV in PDF or DOCX format. Our AI extracts your skills and experience automatically.',
    visual: '📄',
  },
  {
    number: 2,
    icon: 'fa-robot',
    title: 'AI Finds Your Matches',
    description: 'Our machine learning algorithm scans thousands of jobs and ranks the best matches for your profile.',
    visual: '🤖',
  },
  {
    number: 3,
    icon: 'fa-bolt',
    title: 'Auto-Apply',
    description: 'Let JobLinked AI apply to your top matches automatically while you focus on interview prep.',
    visual: '⚡',
  },
  {
    number: 4,
    icon: 'fa-chart-line',
    title: 'Track Everything',
    description: 'Monitor all your applications, responses, and interviews in one clean dashboard.',
    visual: '📊',
  },
];

export const RECRUITER_STEPS = [
  {
    number: 1,
    icon: 'fa-pen-alt',
    title: 'Post Your Job',
    description: 'Create a detailed job posting in minutes. Add screening questions to filter candidates upfront.',
    visual: '📝',
  },
  {
    number: 2,
    icon: 'fa-robot',
    title: 'AI Finds Candidates',
    description: 'Our AI matches your job with qualified candidates and ranks applications based on fit.',
    visual: '🤖',
  },
  {
    number: 3,
    icon: 'fa-star',
    title: 'Review Top Picks',
    description: 'See only the best-ranked candidates. Save hours of manual screening with AI-powered shortlisting.',
    visual: '⭐',
  },
  {
    number: 4,
    icon: 'fa-handshake',
    title: 'Interview & Hire',
    description: 'Schedule interviews directly through the platform and make offers faster than ever.',
    visual: '🤝',
  },
];
